import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPatchRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IClaimTypesResponseSchema,
  IClaimTypesSubmitSchema,
} from "./claimTypesAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllClaimTypesAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IClaimTypesResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.CLAIM_TYPES, searchParams, signal });

const getSingleClaimTypesAPI = (
  id: string
): Promise<{ data: IClaimTypesResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.CLAIM_TYPES}/${id}`,
  });

const createClaimTypesAPI = (
  data: Omit<IClaimTypesSubmitSchema, "id">
): Promise<{ data: IClaimTypesResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.CLAIM_TYPES, data });

const updateClaimTypesAPI = (
  data: Required<Pick<IClaimTypesSubmitSchema, "id">> &
    Partial<IClaimTypesSubmitSchema>
): Promise<{ data: IClaimTypesResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.CLAIM_TYPES}/${data.id}`, data });

const deleteClaimTypesAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.CLAIM_TYPES}/${id}` });

export {
  getAllClaimTypesAPI,
  getSingleClaimTypesAPI,
  createClaimTypesAPI,
  updateClaimTypesAPI,
  deleteClaimTypesAPI,
};
